export { default } from './SkeletonFlightRecommender';
